import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import { RenderWhen } from "../../../../../../components";
import RLCard from "../../../../../../components/card/RLCard";
import useModal from "../../../../../../hooks/useModal";
import shortNumberFormat from "../../../../../../tcbase/utils/short_number_format";
import { COMPONENT_IDS, SECTIONS } from "../../../../consts";
import PreviewAndVisualizationModalContainer from "../../../../containers/PreviewAndVisualizationModalContainer";
import commonStyles from "../../../../containers/report_summary/report-summary.module.scss";
import {
  useGetReportSummary,
  useLocalSampleSummaryParams
} from "../../../../hooks";
import { pathToSS } from "../../../../util";
import { DESCRIPTIONS } from "../../../layout-editor/consts";
import { SUMMARY_YARA_MATCHES_ID } from "../../../summary/SummaryYaraMatches";
import { Tooltip } from "../common";
import YaraMatchesGrid from "./YaraMatchesGrid";
import { getNumberOfYaraMatches } from "./utils";

export const YARA_MATCHES_CARD_ID = "yara-matches-card";

const YaraMatchesCard = () => {
  const [previewModalShow, , togglePreviewModal] = useModal();
  const navigate = useNavigate();
  const { hash, sourceId, relationshipId } = useLocalSampleSummaryParams();
  const { data, isLoading } = useGetReportSummary(
    hash,
    sourceId,
    relationshipId
  );

  const linkToHWCT = pathToSS(
    hash,
    sourceId,
    SECTIONS.FILE_ANALYSIS.HOW_WE_CAUGHT_THIS,
    relationshipId
  );

  const handleSeeAllMatchesClick = () => {
    navigate(linkToHWCT, {
      state: { scrollTo: SUMMARY_YARA_MATCHES_ID }
    });
  };

  const yaraMatchesCount = shortNumberFormat(
    getNumberOfYaraMatches(data?.yara_matches)
  );

  return (
    <>
      <RLCard
        id={YARA_MATCHES_CARD_ID}
        header={
          <RLCard.LinkHeader
            title={
              <Tooltip
                placement="top"
                message={
                  <div>
                    <span>{DESCRIPTIONS[COMPONENT_IDS.YARA_MATCHES]}</span>
                    <br />
                    <span>
                      Total number of matched YARA rulesets: {yaraMatchesCount}.
                    </span>
                  </div>
                }
              >
                <span>{`YARA Matches (${yaraMatchesCount})`}</span>
              </Tooltip>
            }
            LinkComponent={
              <RenderWhen condition={!!data?.yara_matches.length}>
                <div className={"flex flex-gap-3 k-pdf-hide-in-pdf"}>
                  <a
                    onClick={togglePreviewModal}
                    className={commonStyles.link}
                    data-testid="summary_report_yara_preview_link"
                  >
                    See Preview
                  </a>
                  <div className={commonStyles.header_divider} />
                  <a
                    onClick={handleSeeAllMatchesClick}
                    className={commonStyles.link}
                    data-testid="summary_report_yara_all_matches_link"
                  >
                    See All Matches
                  </a>
                </div>

                <a
                  href={linkToHWCT}
                  className={clsx(commonStyles.link, "k-pdf-show-in-pdf")}
                  data-testid="summary_report_yara_preview_link"
                  style={{ display: "none" }}
                >
                  See All Matches
                </a>
              </RenderWhen>
            }
          />
        }
        content={
          <RLCard.Content>
            <YaraMatchesGrid data={data?.yara_matches} isLoading={isLoading} />
          </RLCard.Content>
        }
        data-testid="report_summary_yara_matches_card"
      />
      {hash && sourceId && (
        <RenderWhen condition={previewModalShow}>
          <PreviewAndVisualizationModalContainer
            sha1={hash}
            sourceId={sourceId}
            relationshipId={relationshipId}
            onHide={togglePreviewModal}
          />
        </RenderWhen>
      )}
    </>
  );
};

export default YaraMatchesCard;
